import React from 'react';

import SelectedItemsControls from '@Containers/ResultToolbar/SelectedItemsControls';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import RsTableToolbar from '@Pages/RetroSynthesis/components/RsTableToolbar';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/function-component-definition
const RsProjectRoutesToolbar = ({ selectedCount = 0, onSelectAllClick, isAllSelected, onLimitToClick, onDeleteClick, displayedItems }) => (
  <RsTableToolbar>
    <div className="rs-table-toolbar__left-controls">
      <SelectedItemsControls
        checkAllItems={() => onSelectAllClick()}
        allItemsSelected={isAllSelected}
        currentSelectedItems={selectedCount}
        someItemsSelected={selectedCount > 0 && !isAllSelected}
      />
      {/* TODO Need corresponding Icon from Leyden and use ButtonWithIcon */}
      <Button
        layout="vertical"
        type="borderless"
        size="small"
        className="c-els-button--vertical e2e-rs-toolbar-button-limit-to"
        disabled={!selectedCount || !displayedItems || displayedItems <= 1}
        onClick={onLimitToClick}>
        <span className="icon__wrapper" data-testid="icon-wrapper">
          <svg
            aria-hidden="true"
            focusable="false"
            className="icon o-els-icon-svg o-els-icon-svg--1x1o2 o-els-icon-svg--middle o-els-icon-svg--font-offset"
            role="img"
            data-testid="icon-sprite">
            <use xlinkHref="#icon-screenshot" />
          </svg>
        </span>
        <span className="c-els-button__text">Limit to</span>
      </Button>
      <ButtonWithIcon
        layout="vertical"
        sprite="Trash"
        type="borderless"
        size="small"
        className="e2e-rs-toolbar-button-delete"
        disabled={!selectedCount || selectedCount <= 0}
        onClick={onDeleteClick}>
        Delete
      </ButtonWithIcon>
    </div>
    <div className="rs-table-toolbar__center-controls" />
    <div className="rs-table-toolbar__right-controls">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="rx-checkbox--label" htmlFor="allResults" title="Select all">
        <span className="icon-only-text-label">Select all results</span>
      </label>
    </div>
  </RsTableToolbar>
);

export default RsProjectRoutesToolbar;

RsProjectRoutesToolbar.defaultProps = {
  onLimitToClick: () => null,
  onSelectAllClick: () => null,
  onDeleteClick: () => null,
};

RsProjectRoutesToolbar.propTypes = {
  selectedCount: PropTypes.number,
  displayedItems: PropTypes.number,
  onSelectAllClick: PropTypes.func,
  isAllSelected: PropTypes.bool,
  onLimitToClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
};
